module.exports = __webpack_public_path__ + "files/ae329aec006c03c6abce6a374e6f527b.svg";